/* Sanitizadores para mitigar hallazgos de seguridad (CWE-117, CWE-918, CWE-601, CWE-79) */

const CONTROL_CHARS = /[\u0000-\u001F\u007F-\u009F]/g;
const HAS_CONTROL_CHARS = /[\u0000-\u001F\u007F-\u009F]/;
const HTML_CHARS = /[<>"'`]/g;
const MAX_LOG_LENGTH = 500;

const toStr = (value) => (value === undefined || value === null ? '' : String(value));

/* Neutraliza saltos de linea y caracteres de control antes de escribir en logs (CWE-117) */
export const sanitizeLog = (value) => {
  let text;
  if (value instanceof Error) {
    text = value.message;
  } else if (value !== null && typeof value === 'object') {
    try {
      text = JSON.stringify(value);
    } catch (error) {
      text = '[object]';
    }
  } else {
    text = toStr(value);
  }
  return toStr(text).replace(CONTROL_CHARS, ' ').slice(0, MAX_LOG_LENGTH);
};

/* Codifica un valor para usarlo como segmento o parametro de URL (CWE-918 / CWE-73) */
export const encodeParam = (value) => encodeURIComponent(toStr(value));

/* Elimina caracteres de control y de marcado HTML de un texto ingresado por el usuario (CWE-79) */
export const sanitizeText = (value) =>
  toStr(value).replace(CONTROL_CHARS, '').replace(HTML_CHARS, '');

/* Solo permite rutas internas de la aplicacion; evita redirecciones abiertas (CWE-601) */
export const sanitizeRoute = (route) => {
  const path = toStr(route).trim();
  if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\') || HAS_CONTROL_CHARS.test(path)) {
    return '';
  }
  return path;
};
